import React, { createContext, useContext, useState } from "react";

// Create the context
const PatientContext = createContext();

// Create a provider component
export const PatientProvider = ({ children }) => {
  const [patientData, setPatientsData] = useState(null);

  const handlePatientData = (data) => {
    setPatientsData(data);
  };

  return (
    <PatientContext.Provider value={{ patientData, handlePatientData }}>
      {children}
    </PatientContext.Provider>
  );
};

export const usePatient = () => useContext(PatientContext);
